import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class DealerMerchantIdClient {
  static baseUrl = BASE_URL;

  static getMerchantIds(user) {
    const dealerIds = user.getCommonIdsWithSDLR();

    // Ensure we have valid dealer IDs before making the API call
    if (!dealerIds || dealerIds.trim() === "") {
      return Promise.reject(new Error("No valid dealer IDs available"));
    }

    const url = `${this.baseUrl}/dealer/storeIds?dealerIds=${dealerIds}`;

    return axios
      .get(url, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveMerchantIds(data) {
    const url = `${this.baseUrl}/dealer/storeIds`;

    return axios
      .post(url, data, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
